import AppConfigurationService from '../app-configuration-service/app-configuration-service';
import HttpService from '../http-service/http-service';
import { DSL_API_PATH, DSL_BASE_URL } from '../../constants';
import {
    BookmarkContent,
    BookmarkDataResponse,
} from '../../models/bookmark-data';

export default class BookmarkService {
    appConfig = new AppConfigurationService();

    async getBookmarks(userGuid: string, vin: string) {
        const getBookMarksUrl = `${DSL_BASE_URL +
            DSL_API_PATH.GET_BOOKMARKS}?guid=${userGuid}`;
        return await HttpService.get<BookmarkDataResponse>(
            getBookMarksUrl,
            false,
            {
                headers: {
                    vin,
                    ...HttpService.getAppIdAndAuthTokenRequestHeaders(),
                },
            }
        )
            .then(({ data }) => data)
            .catch(e => {
                console.error('getBookMarksService - ', e);
                return;
            });
    }

    async addBookmark(
        userGuid: string,
        vin: string,
        personalizationValueOne: string,
        personalizationKey: '1'
    ): Promise<BookmarkContent> {
        const addBookMarkUrl = `${DSL_BASE_URL +
            DSL_API_PATH.ADD_BOOKMARK}?guid=${userGuid}&vin=${vin}&personalizationValueOne=${personalizationValueOne}&personalizationKey=${personalizationKey}`;
        return await HttpService.post<any>(addBookMarkUrl, false, {
            headers: {
                vin,
                ...HttpService.getAppIdAndAuthTokenRequestHeaders(),
            },
        })
            .then(({ data }) => data)
            .catch(e => {
                console.error('getBookMarksService - ', e);
                return;
            });
    }

    async deleteBookmark(bookmarkIndex: Number): Promise<BookmarkContent> {
        const deleteBookMarkUrl = `${DSL_BASE_URL +
            DSL_API_PATH.DELETE_BOOKMARK}?bookmarkIndex=${bookmarkIndex}`;

        return await HttpService.delete<any>(encodeURI(deleteBookMarkUrl), {
            headers: HttpService.getAppIdAndAuthTokenRequestHeaders(),
        })
            .then(({ data }) => data)
            .catch(e => {
                console.error('getBookMarksService - ', e);
                return;
            });
    }
}

export const bookmarkService = new BookmarkService();
